module.exports = __webpack_public_path__ + "static/media/05_BOJO_TRIANGULAR_ALCA_REGULAVEL_LISO_03.6a1179d6.jpg";